export const target = {
  drop(props, monitor, target) {
    target.addWidget(monitor.getItem(), monitor.getClientOffset());
    return { cancelSorting: true };
  },

  hover(props, monitor, component) {
    const offset = monitor.getSourceClientOffset();
    component.updateHoverPosition(offset);
  }
};

export function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    getClientOffset: monitor.getClientOffset()
  };
}



// WEBPACK FOOTER //
// ./src/dnd/jumper.js